import { useSessionRecordingStore } from '../audio/useSessionRecordingStore/useSessionRecordingStore';

// Read at call time, not from the hook's render snapshot. STOP can deduplicate
// without joining an in-flight stop, and READY can precede recorder-tail cleanup.
const isCaptureStopped = (): boolean => {
  const { status, activeRecordingKey, recorderStreamId } =
    useSessionRecordingStore.getState();
  return status === 'READY' && activeRecordingKey === null && recorderStreamId === null;
};

export const useSessionRecording = () => {
  const status = useSessionRecordingStore((s) => s.status);
  const start = useSessionRecordingStore((s) => s.startTask);
  const stop = useSessionRecordingStore((s) => s.stopTask);
  return { start, stop, status, isCaptureStopped };
};
